import Header from "components/Headers/Header";
import ResolutionCenterAddModal from "components/ResolutionCenterAddModal";
import ReuseableTable from "components/Tables/ReuseableTable";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Card, Container, Row, Spinner, Table } from "reactstrap";
import { getResolutions } from "store/actions/resolutionCenterAction";

function ResolutionCenter() {
  const { resolutions, lastDocument, hasMoreDocument } = useSelector(
    (state) => state.resolution
  );
  const [loader, setLoader] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [loadMoreLoader, setLoadMoreLoader] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const dispatch = useDispatch();

  const toggleAddModal = () => {
    setAddModal(!addModal);
  };

  const loadMore = () => {
    if (!hasMoreDocument) return;
    setLoader(true);
    dispatch(
      getResolutions(user?.id, lastDocument, () => {
        setLoader(false);
      })
    );
  };

  useEffect(() => {
    setLoadMoreLoader(true);
    dispatch(
      getResolutions(user?.id, "", () => {
        setLoadMoreLoader(false);
      })
    );
  }, []);
  const TABLE_DATA = {
    columns: [
      "#",
      "ID",
      "Name",
      "Created By",
      "Created At",
      "Updated By",
      "Phone No",
      "Status"
    ],
    keyMap: {
      "#": "index",
      ID: "athleteId",
      Name: "name",
      "Created By": "email",
      "Created At": "createdAt",
      "Updated By": "updatedAt",
      "Phone No": "phoneNumber",
      Status: "status"
    },
    data:
      resolutions.length > 0 ? (
        resolutions.map((item, index) => {
          return {
            id: item?.id,
            index: index + 1,
            athleteId: <span className="text-nowrap">{item?.athleteId}</span>,
            name: <span className="text-nowrap"> {item?.name}</span>,
            email: <span className="text-nowrap">{item?.email}</span>,
            createdAt: (
              <span className="text-nowrap">
                {item?.createdAt
                  ? moment
                      .unix(item?.createdAt.seconds)
                      .format("Do MMMM YYYY, h:mm:ss")
                  : "N/A"}
              </span>
            ),
            updatedAt: (
              <span className="text-nowrap">
                {item?.updatedAt
                  ? moment
                      .unix(item?.updatedAt.seconds)
                      .format("Do MMMM YYYY, h:mm:ss")
                  : "N/A"}
              </span>
            ),
            phoneNumber: (
              <span className="text-nowrap"> {item?.phoneNumber}</span>
            ),
            status: (
              <span
                className={`badge ${
                  item?.status === "accepted" ? "badge-success" : "badge-danger"
                }`}
              >
                {item?.status}
              </span>
            )
          };
        })
      ) : (
        <tr>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
          <td>N/A</td>
        </tr>
      ),
    renderActions: (row, rowIndex) => {
      return (
        <Link to={`/admin/resolution-detail/${row?.id}`}>
          <Button size="sm" color="primary" className="text-nowrap px-3">
            View Details
          </Button>
        </Link>
      );
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <Container fluid>
        <Card className="p-3">
          <Row className="justify-content-between align-items-center px-4 mb-3">
            <h1
              className="text-left"
              style={{ fontSize: isSmallScreen ? "13px" : "26px" }}
            >
              Resolution Center
            </h1>
            <Button
              color="primary"
              className="float-right"
              onClick={toggleAddModal}
            >
              Add Resolution
            </Button>
          </Row>
          {loadMoreLoader ? (
            <div className="d-flex align-items-center justify-content-center py-4">
              <Spinner size="md" color="primary" />
            </div>
          ) : (
            <>
              <ReuseableTable {...TABLE_DATA} />
            </>
          )}
          {resolutions.length > 4 && hasMoreDocument && (
            <div className="text-center mt-3">
              <Button color="primary" onClick={loadMore} disabled={loader}>
                {loader ? <Spinner size="sm" /> : " Load more"}
              </Button>
            </div>
          )}{" "}
        </Card>
      </Container>

      <ResolutionCenterAddModal
        addModal={addModal}
        toggleAddModal={toggleAddModal}
      />
    </>
  );
}

export default ResolutionCenter;
